import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  formContainer: {
    display: "flex",
    flexDirection: "column"
  },
  receiptItemHeader: {
    display: "flex",
    justifyContent: "space-between"
  },
  receiptItemName: {
    color: theme.palette.grey[600]
  },
  receiptItemPrice: {
    fontWeight: theme.typography.fontWeightBold
  },
  receiptItemQuantityContainer: {
    display: "flex",
    justifyContent: "space-between",
    color: theme.palette.grey[400]
  },
  receiptItemQuantity: {},
  receiptItemRefundQuantity: {},
  receiptTotal: {
    display: "flex",
    justifyContent: "flex-end"
  },
  discount: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));
